module.exports = __webpack_public_path__ + "static/media/HCMM697.0ac2d858.jpg";